import type { TButton } from '~/types/shared-props'

export enum EFILE_DOWNLOAD_VARIANT {
  SIMPLE = 'simple',
  DEFAULT = 'default'
}
export interface IProps {
  label: string,
  variant?: EFILE_DOWNLOAD_VARIANT,
  button: TButton,
  format?: string,
  size?: number | string
}
